<template>
  <div class="gs-app gs-vendor-settings">
    <!-- Vendor Settings Tabs -->
    <div>
      <v-wait for="settings">
        <div>
          <header class="gs-vendor-settings__header gs-wizard-card">
            <p class="gs-vendor-settings__eyebrow">
              {{ $t('frontend_gduikit_sidebar_vendor_setting') }}
            </p>
            <h1>
              {{ $t('frontend_funnels_vendor_settings') }}
            </h1>
            <p class="gs-vendor-settings__subtitle">
              {{$t('frontend_funnels_you_can_configure')}}
            </p>
          </header>

          <section class="gs-vendor-settings__layout gs-wizard-card">
            <vertical-tabs
              :tabs="vendorSettingsTabs"
              :currentTab="vendorSettingsTab"
              :wrapper-class="'gs-vendor-settings__tabs'"
              @onClick="handleVendorSettingsTabChange"
            />
            <div class="gs-vendor-settings__content">
              <payment-gateways v-if="vendorSettingsTab === 'setupGateways'" />
              <manage-domains  v-if="vendorSettingsTab === 'manageDomains'" />
              <facebook-conversion-pixels v-if="vendorSettingsTab === 'facebook_conversion'" />
              <self-billing  v-if="vendorSettingsTab === 'selfbilling'" />
            </div>
          </section>
        </div>
      </v-wait>
    </div>
  </div>
</template>

<script>
import VerticalTabs from '@/components/VerticalTabs';
import PaymentGateways from './index-partials/PaymentGateways.vue';
import ManageDomains from './index-partials/ManageDomains.vue';
import SelfBilling from './index-partials/SelfBilling.vue';
import FacebookConversionPixels from './index-partials/FacebookConversionPixels.vue';

export default {
  middleware: 'auth',
  components: {
    VerticalTabs,
    PaymentGateways,
    ManageDomains,
    SelfBilling,
    FacebookConversionPixels,
  },
  data() {
    return {
      vendorSettingsTab: 'setupGateways',
    };
  },
  metaInfo() {
    return { title: this.$t('vendor_settings') };
  },
  computed: {
    vendorSettingsTabs () {
      return [
        {
          title: this.$t('groovesell_vendor_settings_payment_gateways'),
          value: 'setupGateways',
        },
        {
          title: this.$t('groovesell_vendor_settings_manage_domains'),
          value: 'manageDomains',
        },
        {
          title: this.$t('frontend_facebook_conversion_api_detail'),
          value: 'facebook_conversion',
        },
        {
          title: this.$t('frontend_funnels_self_billing'),
          value: 'selfbilling',
        }
      ]
    },
  },
  methods: {
    handleVendorSettingsTabChange(newTab) {
      this.vendorSettingsTab = newTab;
    },
  },
};
</script>

<style lang="scss">
.gs-vendor-settings {
  color: var(--gs-foreground);
}

.gs-vendor-settings .gs-wizard-card {
  padding: 20px 24px;
  background: var(--gs-surface);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-lg);
  box-shadow: var(--gs-shadow-sm);
}

.gs-vendor-settings__eyebrow {
  margin: 0 0 4px;
  color: var(--gs-primary);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.gs-vendor-settings__header h1 {
  margin: 0 0 6px;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.2;
}

.gs-vendor-settings__subtitle {
  margin: 0;
  color: var(--gs-muted-foreground);
  font-size: 14px;
}

.gs-vendor-settings__layout {
  display: grid;
  grid-template-columns: 240px minmax(0, 1fr);
  gap: 28px;
  margin-top: 20px;
}

.gs-vendor-settings__tabs {
  align-self: start;
}

.gs-vendor-settings__content {
  min-width: 0;
}

@media (max-width: 900px) {
  .gs-vendor-settings__layout {
    grid-template-columns: 1fr;
  }
}

.scroll-modal {
  max-height: calc(100vh - 80px);
}
</style>
